import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {DataService} from '../../../../Services/data.service';
import {NotificationService} from '../../../../Services/notification.service';
import {Title} from '@angular/platform-browser';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {HttpErrorResponse} from '@angular/common/http';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';
import { ResponseModel } from '../../../../DataModels/response-model';
import {NavigationService} from '../../../../Services/navigation.service';

@Component({
  selector: 'app-tax-form',
  templateUrl: './tax-form.component.html',
  styleUrls: ['./tax-form.component.css'],
  standalone: false
})
export class TaxFormComponent implements OnInit {

  taxForm: UntypedFormGroup;

  vm: any = {};
  taxId;
  submitted = false;
  private originalItem = {};
  originalSnapshot: any = {};

  buttonConfig: any = {
    save: true,
    close: true,
    reset: true,
    delete: true,
    saveNew: true,
    saveClose: true,
    print: false,
  };

  constructor(private route: ActivatedRoute,
              private router: Router,
              private tableDataService: DataService,
              private notification: NotificationService,
              private titleService: Title,
              private formBuilder: UntypedFormBuilder,
              private confirmDialogService: ConfirmDialogService,
              private nav: NavigationService) {

    this.route.queryParamMap.subscribe((params: ParamMap) => {
      this.taxId = params.get('taxId');
    });
    // this.taxId = this.route.snapshot.params.id;

    this.vm.item = {};
  }

  ngOnInit() {
    this.titleService.setTitle($localize`:Tax @@tax:Tax`);

    this.taxForm = this.formBuilder.group({
      code: new UntypedFormControl('', Validators.required),
      name: new UntypedFormControl('', Validators.required),
      collected_account_id: new UntypedFormControl('', Validators.required),
      paid_account_id: new UntypedFormControl(''),
      active: new UntypedFormControl(true)
    });

    if (this.taxId === 'new') {
      this.vm.item = {};
      this.vm.item.id = 'new';
      this.vm.auditTrail = {};
      Promise.resolve().then(() => {
        try {
          this.originalSnapshot = this.buildSnapshot();
        } catch {
        }
      });
    } else {
      this.buttonConfig.reset = false;
      this.tableDataService.getData('tax', this.taxId).toPromise().then((result: any) => {
        this.vm.item = result;
        this.vm.auditTrail = Object.assign({}, this.vm.item);
        this.originalItem = Object.assign({}, this.vm.item);
        this.taxForm.patchValue(this.vm.item);
        try {
          this.originalSnapshot = this.buildSnapshot();
        } catch {
        }
      });
    }

    this.tableDataService.getApiListData('account', '?state=active&pageNumber=0&pageSize=999999').subscribe((result: ResponseModel) => {
      this.vm.account = result.Data;
    });
  }

  loadAfterSave() {
    this.tableDataService.getData('tax', this.taxId).subscribe((result: any) => {
      this.vm.item = result;
      this.vm.auditTrail = Object.assign({}, this.vm.item);
      this.originalItem = Object.assign({}, this.vm.item);
      this.taxForm.patchValue(this.vm.item);
      try {
        this.originalSnapshot = this.buildSnapshot();
      } catch {
      }
    });
  }


  saveClose() {
    if (this.onSave(true)) {
    }
  }

  saveNew() {
    // Defer reset until async save completes inside onSave(false)
    this.onSave(false);
  }

  deleteItem() {
    let retMsg = '';
    const messages: string[] = [$localize`:Are you sure you want to delete tax? @@areYouSureYouWantToDeleteTax:Are you sure you want to delete tax?`, this.vm.item.name];
    this.confirmDialogService.confirmThis(
      messages,
      () => {
        this.tableDataService.deleteDataById('tax', this.taxId).subscribe(
          (result) => {
            retMsg = result;
            // this.notification.success($localize`:Deleted@@deleted:Deleted`);
          },
          (error: HttpErrorResponse) => {
            //  this.notification.error($localize`:Error @@error:Error`);
            console.log(error);
          },
          () => {
            this.onClose();
          }
        );
      },
      () => {
        this.notification.success($localize`:Delete Canceled@@deleteCanceled:Delete Canceled`);
      }
    );
  }

  private resetToDefaults(): void {
    // Reset form to known defaults and prepare component for a fresh new entry
    this.taxForm.reset({
      code: '',
      name: '',
      collected_account_id: '',
      paid_account_id: '',
      active: true,
    });
    this.vm.item = {};
    this.vm.item.id = 'new';
    this.vm.auditTrail = {};
    this.originalItem = {};
    this.taxId = 'new';
    this.submitted = false;
    try {
      this.originalSnapshot = this.buildSnapshot();
    } catch {
    }
  }

  resetForm() {
    this.resetToDefaults();
  }

  onClose() {
    const fallback = '/admin/tax-list';
    this.nav.backOr(fallback);
  }

  onSave(saveClose: boolean) {
    let retval = false;
    if (!this.taxForm.valid) {
      this.notification.error($localize`:Please fill required fields! @@pleasefillrequiredfields:Please fill required fields!`);
      return;
    }

    this.vm.item = Object.assign(this.vm.item, this.taxForm.value);
    this.vm.buttonsDisabled = true;
    const errorMessage = '';

    if (errorMessage === '') {

      if (this.vm.item.id === 'new') {
        // console.log('id: ' + this.vm.item.id );
        this.tableDataService.post('tax', this.vm.item).subscribe((item: any) => {
          // stops double posting when clicking Save
          let apiReturn: any = null;
          if (typeof item === 'object') {
              apiReturn = JSON.parse(JSON.stringify(item));
            }
          this.vm.item.id = apiReturn.id;
          retval = true;
          // After successful create, either close or prepare a clean form for another entry
          if (saveClose) {
            this.onClose();
          } else {
            this.resetToDefaults();
          }
          try {
            this.originalSnapshot = this.buildSnapshot();
          } catch {
          }
          this.vm.buttonsDisabled = false;
        }, (error: { error: { Message: string }, statusText: string }) => {
          this.vm.buttonsDisabled = false;
          let ErrorMsg: string;
          if (typeof error.error.Message != 'undefined') {
            ErrorMsg = error.error.Message;
          } else {
            ErrorMsg = error.statusText;
          }
          this.notification.error(ErrorMsg);
          retval = false;
          if (saveClose){
            this.onClose();
          }
        });
      } else {
        const changes = {};
        for (const key in this.vm.item) {
          if (Object.prototype.hasOwnProperty.call(this.vm.item, key)) {
            const value = this.vm.item[key];
            if (value != this.originalItem[key] && typeof(value) != 'object') {
              changes[key] = value;
            }
          }
        }

        this.tableDataService.patch('tax', this.vm.item.id, changes)
          .then((item: any) => {
            retval = true;
            if (saveClose){
              this.onClose();
            } else {
              this.resetToDefaults();
            }
            try {
              this.originalSnapshot = this.buildSnapshot();
            } catch {
            }
            this.vm.buttonsDisabled = false;
          })
          .catch((msg: string) => {
            this.vm.buttonsDisabled = false;
            retval = false;
          });
      }
    } else {
      this.vm.buttonsDisabled = false;
      // this.notification.error(errorMessage);
      console.log(errorMessage);
    }
    this.submitted = false;

    // if (this.vm.item.id === 'new') {
    //   this.resetForm();
    // }
    return retval;
  }

  buildSnapshot(): any {
    try {
      return this.taxForm.getRawValue();
    } catch {
      return {};
    }
  }

  hasChanges(): boolean {
    try {
      const current = this.buildSnapshot();
      const original = this.originalSnapshot || {};
      return JSON.stringify(current) !== JSON.stringify(original);
    } catch {
      return false;
    }
  }

  checkForChanges(): boolean {
    return this.hasChanges();
  }
}
